import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Sticky from 'react-stickynode';
import Logo from '../images/logo-small.png'
import { TopBar, TopBarItem, TopBarTitle } from 'react-foundation-components/lib/global/top-bar';
import { Menu, MenuItem } from 'react-foundation-components/lib/global/menu';
import MenuIcon from 'react-foundation-components/lib/global/menu-icon';
import { ShowForScreenSize, ShowOnlyForScreenSize, HideOnlyForScreenSize, HideForScreenSize } from 'react-foundation-components/lib/global/visibility';
import { Row, Column } from 'react-foundation-components/lib/global/grid';

class MainMenu extends Component {
  constructor(props) {
    super(props);

    this.handleToggle = this.handleToggle.bind(this)
    this.state = {
      show: false,
    }
  }

  handleToggle() {
    this.setState(prevState => ({
      show: !prevState.show,
    }))
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.show) {
      this.handleToggle()
    }
  }

  render() {
    return (
      <Sticky activeClass="sticky-nav-active" enabled={true} top={0} innerZ={100}>
        <TopBar stack="medium" className="title-bar">
          <Row>
            <Column className="small-12">
              <TopBarTitle style={{ padding: '0' }}>
                <Link to="/"><img src={Logo} alt="4x4 Driving School Logo" /></Link>
              </TopBarTitle>
              <HideForScreenSize screenSize="large">
                <div className="menu-tap float-right">
                  <MenuIcon onClick={this.handleToggle} />
                  <div className="title-bar-title" onClick={this.handleToggle}>Menu</div>
                </div>
              </HideForScreenSize>
              <ShowForScreenSize screenSize={this.state.show ? 'small' : 'large'}>
                <TopBarItem position="right" className='nav-menu'>
                  <Menu vertical horizontal="large">
                    <MenuItem>
                      <Link activeClassName="menu-item-active" exact to="/">Home</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/corporate">Corporate Days</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/stag-and-hen-parties">Stag and Hen</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/packages">Packages</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/bookings">Bookings</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/faqs">FAQs</Link>
                    </MenuItem>
                    <MenuItem>
                      <Link activeClassName="menu-item-active" to="/contact">Contact</Link>
                    </MenuItem>
                  </Menu>
                </TopBarItem>
              </ShowForScreenSize>
            </Column>
          </Row>
        </TopBar>
      </Sticky>
    )
  }
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/layouts/menu.js